import React from "react";
import { useLaunchpadStore } from "../launchpadStore";
import { Button } from "@puzzle/ui";
import links from "lib/links";
import Analytics from "lib/analytics/analytics";
import { LaunchpadSource } from "../analytics";
import { useOnboardingProgress } from "../useOnboardingProgress";
import { BOOK_CALL_LABEL, DEFAULT_TASKLIST_DESCRIPTION } from "../constants";
import { LeftSectionContentContainer } from "./LeftSectionContentContainer";
import { useActiveCompany } from "components/companies/ActiveCompanyProvider";
import { Link } from "components/common/Link";

export const DefaultLaunchpadBannerContent = () => {
  const { showScheduleOnboardingCall, dismissLaunchpadBanner } = useOnboardingProgress();
  const { showLaunchpadOverlay } = useLaunchpadStore();
  const { isICPCompany } = useActiveCompany();

  const getStartedButton = (
    <Button
      key="get-started"
      variant={isICPCompany ? "secondary" : "primary"}
      onClick={() => {
        showLaunchpadOverlay();
        dismissLaunchpadBanner();
      }}
    >
      Get Started
    </Button>
  );
  const bookADemoButton = showScheduleOnboardingCall ? (
    <Link external href={links.freeConciergeOnboarding}>
      <Button
        key="book-a-demo"
        variant={isICPCompany ? "primary" : "secondary"}
        onClick={() => {
          Analytics.onboardingCallCtaClicked({
            Source: LaunchpadSource.DashboardLaunchpadBanner,
          });
        }}
      >
        {BOOK_CALL_LABEL}
      </Button>
    </Link>
  ) : null;

  const buttons = [getStartedButton, bookADemoButton].filter(Boolean);

  return (
    <LeftSectionContentContainer description={DEFAULT_TASKLIST_DESCRIPTION}>
      {isICPCompany ? buttons : buttons.reverse()}
    </LeftSectionContentContainer>
  );
};
